document.addEventListener('DOMContentLoaded', () => {

/*
==== ==== ==== ==== FAQ items */        
    const faqItems = document.querySelectorAll('.faq_item');
    if (faqItems.length) {
/*
==== ==== ==== ==== FAQ item add iteration classes */    
        document.querySelectorAll('.faq_item').forEach((el, i) => {
            el.classList.add('s' + (i + 1));
        });  

/*
==== ==== ==== ==== FAQ item accordeon script */
        const DURATION = 300;

        faqItems.forEach(title => {
            title.addEventListener('click', () => {
            const parent = title.closest('.faq_item');
            const target = parent.querySelector('.faq_content');
            if (!target) return;

            // Закрыть другие
            document.querySelectorAll('.faq_item.is_open').forEach(tab => {
                const content = tab.querySelector('.faq_content');
                if (tab !== parent) slideUp(tab, content);
            });

            if (parent.classList.contains('is_open')) {
                slideUp(parent, target);
            } else {
                slideDown(parent, target);
            }
            });
        });

        function slideDown(tab, el) {
            tab.classList.add('is_open');
            el.style.removeProperty('display');
            el.style.display = 'block';
            let h = el.scrollHeight;
            animate(el, 0, h, DURATION, () => {
            el.style.height = '';
            el.style.overflow = '';
            });
        }

        function slideUp(tab, el) {
            let h = el.scrollHeight;
            animate(el, h, 0, DURATION, () => {
            el.style.display = 'none';
            tab.classList.remove('is_open');
            el.style.height = '';
            el.style.overflow = '';
            });
        }

        function animate(el, from, to, duration, cb) {
            let start = null;
            el.style.overflow = 'hidden';

            function step(ts) {
            if (!start) start = ts;
            let progress = Math.min((ts - start) / duration, 1);
            let val = from + (to - from) * progress;
            el.style.height = val + 'px';
                if (progress < 1) {
                    requestAnimationFrame(step);
                } else {
                    cb && cb();
                }
            }
            requestAnimationFrame(step);
        }

        
        (function init() {
            document.querySelectorAll('.faq_item').forEach(tab => {
            const content = tab.querySelector('.faq_content');
            if (tab.classList.contains('s999')) {
                tab.classList.add('is_open');
                content.style.display = 'block';
            } else {
                if (!tab.classList.contains('is_open')) {
                content.style.display = 'none';
                } else {
                content.style.display = 'block';
                }
            }
            });
        })();
    }   /* /END if FAQ items length */
/*
==== ==== ==== ==== /END FAQ items */

});